module.exports = __webpack_public_path__ + "img/hamochi_shock.ce1921d5.png";